"use client"

import { useTheme } from "next-themes"
import { useEffect, useState } from "react"

// The BOOTH wordmark: white-text logo in dark mode, black-text in light mode.
// One <img>, source swapped by theme — simple, can never render two at once.
//
// `surface` overrides that for a panel painted one colour in BOTH themes — a
// modal forced white, say. Following the theme there renders the white-text
// logo on a white card, i.e. nothing at all.
export function BoothWordmark({
  className,
  style,
  surface = "auto",
}: {
  className?: string
  style?: React.CSSProperties
  surface?: "auto" | "light" | "dark"
}) {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  const onDarkSurface = surface === "auto" ? mounted && resolvedTheme === "dark" : surface === "dark"
  const src = onDarkSurface ? "/images/booth-wordmark-dark.webp" : "/images/booth-wordmark-light.webp"
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} alt="BOOTH" className={className} style={style} />
}
